import classNames from 'classnames'
import Message, { useTranslation } from 'maeng-utils/locale'
import React, { useMemo } from 'react'

type EducationItem = {
  term: string
  title: string
  description: string
}

const Educations = () => {
  const { t } = useTranslation()

  const educations = useMemo<EducationItem[]>(() => t('portfolio.educations.educations'), [t])

  return (
    <section className="mb-12">
      <Message
        i18nKey="portfolio.educations.title"
        className="text-3xl font-extrabold pt-5 pb-8"
        component="h2"
      />
      <div className="flex flex-col px-4">
        {educations.map(({ term, title, description }) => (
          <div
            className={classNames(
              'flex w-full h-full p-4 gap-4',
              "before:content-[''] before:w-[5px] before:bg-[#ccd5dd]",
            )}
            key={title}
          >
            <div className="w-full">
              <div className="text-sm">{`[${term}]`}</div>
              <div className="text-lg font-medium mb-1">{title}</div>
              <div className="text-[#8a8e94]">{description}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Educations
